import { z } from 'zod';

export const SLOT_ALREADY_BOOKED_CODE = 'SLOT_ALREADY_BOOKED';
export const SLOT_IS_IN_PAST = 'SLOT_IS_IN_PAST';

export const slotConflictSchema = z.object({
    code: z.literal(SLOT_ALREADY_BOOKED_CODE),
    details: z.object({
        slot: z.iso.datetime(),
    }),
});

// The conflict body may arrive raw or wrapped under `data` by the api-client interceptor (ApiError).
export const slotConflictErrorSchema = z.union([
    slotConflictSchema,
    z.object({ data: slotConflictSchema }).transform(({ data }) => data),
]);

export const appointmentInPastSchema = z.object({
    code: z.literal(SLOT_IS_IN_PAST),
});

// The error body may arrive raw or wrapped under `data` by the api-client interceptor (ApiError).
export const appointmentInPastErrorSchema = z.union([
    appointmentInPastSchema,
    z.object({ data: appointmentInPastSchema }).transform(({ data }) => data),
]);
